import React, { useState, useEffect } from 'react';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const TagsField = ({ 
  value, 
  onChange, 
  isEditingMode, 
  label,
  disablePadding
}) => {
  const [tags, setTags] = useState([]);

  useEffect(() => {
    if (value && typeof value === 'string') {
      const parsedTags = value.split(',').map(tag => tag.trim()).filter(tag => tag.length > 0);
      setTags(parsedTags);
    } else {
      setTags([]);
    }
  }, [value]);

  const handleTagsChange = (event, newTags) => {
    setTags(newTags);
    onChange(newTags.join(', '));
  };

  const renderTags = (tagValue, getTagProps) => {
    return tagValue.map((option, index) => (
      <Chip
        {...getTagProps({ index })}
        key={option}
        label={option}
        color="primary"
        variant="outlined"
        size="small"
      />
    ));
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 2,
        p: disablePadding ? 0 : 0.5,
        minHeight: 40,
      }}
    >
      {label && (
        <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 120, pt: 1 }}>
          {label}:
        </Typography>
      )}
      
      <Box sx={{ flex: 1 }}>
        {isEditingMode ? (
          <Autocomplete
            multiple
            freeSolo
            options={[]}
            value={tags}
            onChange={handleTagsChange}
            renderTags={renderTags}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                size="small"
                helperText="Type the tag you want to add (e.g. BIN:1234) and press enter to generate the chip."
                sx={{ minWidth: 300 }}
              />
            )}
          />
        ) : (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {tags.map((tag) => (
              <Chip key={tag} label={tag} color="primary" variant="outlined" size="small" />
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default TagsField;